import type { LevelScreenModel } from './LevelScreenModelScreen';

export class LevelScreenController {
  constructor(private readonly model: LevelScreenModel) {}

  handlePause = () => {
    this.model.onPause?.();
  };
}
